module.exports = __webpack_public_path__ + "cloud.jpg?c1dbb51c08adf514ad66e24f6d7ea115";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloud.jpg
// module id = 72
// module chunks = 0